module.exports = __webpack_public_path__ + "img/about-thumb.66f3b844.png";